import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  addProductIdsToManualAssortment,
  deleteProductIdsFromManualAssortment
} from "../../../../commons/libs/assortment";
import { ManualAssortmentItem } from "../../../../commons/types/assortment";
import { PackageInfo } from "../../../../commons/types/content";

interface CoreSliceState {
  isInitCoreDone: boolean;
  isInitAppDone: boolean;
  lastInteraction: number;
  contentPackages: PackageInfo[];
  manualAssortment: ManualAssortmentItem[];
}

const initialState: CoreSliceState = {
  isInitCoreDone: false,
  isInitAppDone: false,
  lastInteraction: 0,
  contentPackages: [],
  manualAssortment: []
};

const coreSlice = createSlice({
  name: "core",
  initialState,
  reducers: {
    initCoreDone: state => {
      state.isInitCoreDone = true;
      state.lastInteraction = new Date().getTime();
    },
    initAppDone: state => {
      state.isInitAppDone = true;
    },
    contentPackagesReceived: (state, action: PayloadAction<PackageInfo[]>) => {
      state.contentPackages = action.payload;
    },
    interact: state => {
      state.lastInteraction = new Date().getTime();
    },
    manualAssortmentReceived: (state, action: PayloadAction<ManualAssortmentItem[]>) => {
      state.manualAssortment = action.payload;
    },
    addManualAssortment: (state, action: PayloadAction<ManualAssortmentItem[]>) => {
      state.manualAssortment = addProductIdsToManualAssortment(action.payload, state.manualAssortment);
    },
    deleteManualAssortment: (state, action: PayloadAction<ManualAssortmentItem[]>) => {
      state.manualAssortment = deleteProductIdsFromManualAssortment(action.payload, state.manualAssortment);
    }
  }
});

export default coreSlice;
